import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Kbd, Mono } from '../shared/components/redesign';
import styles from './ShortcutsOverlay.module.css';

const GROUPS = [
  {
    label: 'Editor',
    rows: [
      { keys: ['←', '→'], desc: 'Navigate prev / next' },
      { keys: ['1', '2', '3', '4'], desc: 'Jump to section' },
      { keys: ['D'], desc: 'Mark done' },
      { keys: ['7'], desc: 'Skip photo' },
      { keys: ['S'], desc: 'Toggle crop mode' },
      { keys: ['Alt', 'V'], desc: 'Cycle viz layers' },
      { keys: ['\\'], desc: 'Compare original (hold)' },
    ],
  },
  {
    label: 'Crop mode',
    rows: [
      { keys: ['Esc'], desc: 'Exit without saving' },
      { keys: ['↵'], desc: 'Confirm crop' },
      { keys: ['R'], desc: 'Reset crop' },
      { keys: ['Q'], desc: 'Full frame' },
      { keys: ['X'], desc: 'Flip orientation' },
      { keys: ['←', '→', '↑', '↓'], desc: 'Pan' },
      { keys: ['Shift', '←/→'], desc: 'Tilt' },
    ],
  },
  {
    label: 'Shell',
    rows: [
      { keys: ['?'], desc: 'Toggle this menu' },
      { keys: ['Esc'], desc: 'Close menus / dialogs' },
    ],
  },
];

export default function ShortcutsOverlay({ open, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className={styles.backdrop} onMouseDown={onClose}>
      <div
        className={styles.panel}
        role="dialog"
        aria-label="Keyboard shortcuts"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className={styles.header}>
          <Mono className={styles.eyebrow}>Keyboard shortcuts</Mono>
          <button type="button" className={styles.close} onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className={styles.body}>
          {GROUPS.map((group) => (
            <div key={group.label} className={styles.group}>
              <Mono className={styles.groupLabel}>{group.label}</Mono>
              <div className={styles.rows}>
                {group.rows.map((row, i) => (
                  <div key={i} className={styles.row}>
                    <span className={styles.keys}>
                      {row.keys.map((k, j) => (
                        <Kbd key={j}>{k}</Kbd>
                      ))}
                    </span>
                    <span className={styles.desc}>{row.desc}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.body,
  );
}
